import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomeComponent } from './layout/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { VendorInvoiceComponent } from './forms/vendor-invoice/vendor-invoice.component';
import { VendorRegistrationComponent } from './forms/vendor-registration/vendor-registration.component';
import { MultipleInvoicesComponent } from './forms/multiple-invoices/multiple-invoices.component';
import { ProfileComponent } from './profile/profile.component';
import { VendorSingupComponent } from './profile/vendor-singup/vendor-singup.component';
import { InvoiceHistoryComponent } from './reports/invoice-history/invoice-history.component';
import { authGuard } from './auth/auth.guard';
import { InformationChangeRequestComponent } from './forms/information-change-request/information-change-request.component';
import { PurchaseOrderHistoryComponent } from './reports/purchase-order-history/purchase-order-history.component';
import { VendorForgotPasswordComponent } from './profile/vendor-forgot-password/vendor-forgot-password.component';
import { NotFoundComponent } from './layout/util/not-found/not-found.component';
import { VendorResetPasswordComponent } from './profile/vendor-reset-password/vendor-reset-password.component';
import { InvoiceAccessGuard } from './auth/invoice-access.guard';
import { RegistrationAccessGuard } from './auth/registration-access.guard';
import { SignupAccessGuard } from './auth/signup-access.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [SignupAccessGuard],
        title: 'Login',
      },
      {
        path: 'home',
        component: HomeComponent,
        title: 'Home',
      },
      {
        path: 'vendor-invoice',
        component: VendorInvoiceComponent,
        canActivate: [InvoiceAccessGuard],
        title: 'Vendor Invoice Submission',
      },
      {
        path: 'vendor-registration',
        component: VendorRegistrationComponent,
        canActivate: [RegistrationAccessGuard],
        title: 'Vendor Registration',
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard],
        title: 'Profile',
      },
      {
        path: 'vendor-sign-up',
        component: VendorSingupComponent,
        canActivate: [SignupAccessGuard],
        title: 'Vendor Sign Up',
      },
      {
        path: 'vendor-forgot-password',
        component: VendorForgotPasswordComponent,
        canActivate: [SignupAccessGuard],
        title: 'Forgot Password',
      },
      {
        path: 'multiple-invoices',
        component: MultipleInvoicesComponent,
        canActivate: [InvoiceAccessGuard],
        title: 'Multiple Invoices',
      },
      {
        path: 'invoice-history',
        component: InvoiceHistoryComponent,
        canActivate: [authGuard],
        title: 'Invoice History',
      },
      {
        path: 'information-change-request',
        component: InformationChangeRequestComponent,
        canActivate: [authGuard],
        title: 'Information Change Request',
      },
      {
        path: 'purchase-order-history',
        component: PurchaseOrderHistoryComponent,
        canActivate: [authGuard],
        title: 'Purchase Order History',
      },
      {
        path: 'reset-password',
        component: VendorResetPasswordComponent,
        canActivate: [SignupAccessGuard],
        title: 'Reset Password',
      },
    ],
  },
  {
    path: '404',
    component: NotFoundComponent,
    title: 'Page Not Found',
  },
  // Wildcard Route: Must be the last route
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Page Not Found',
  },
];
